import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Cut from './Cut.jsx'
import CutMaker from './CutMaker.jsx'
import AuthenticityToken from '../AuthenticityToken.jsx'
import './assets/tube.scss'

const Tube = ({
  products, replaceBasketItemId, vatRate, defaultSize
}) => {
  const [cuts, setCuts] = useState([])

  const addCut = (product, length, quantity) => {
    setCuts(
      cuts.concat({ product, length, quantity })
    )
  }

  const deleteCut = (index) => {
    setCuts((currentCuts) => currentCuts.filter((_cut, cutIndex) => (
      index !== cutIndex
    )))
  }

  const cutComponents = () => (
    cuts.map((cut, index) => (
      <Cut
        key={index}
        index={index}
        cut={cut}
        onDeleteCut={() => deleteCut(index)}
        vatRate={vatRate}
      />
    ))
  )

  return (
    <section id="new_cut_to_size_options" className="new_cut_to_size_options group galv-cuts">
      <CutMaker
        products={products} defaultSize={defaultSize} vatRate={vatRate} onAddCut={addCut}/>
      <form className="galv-cuts-form"
        action="/galvanised-tubes/add-to-basket"
        method="post"
        acceptCharset="UTF-8"
        encType="multipart/form-data"
      >
        <input type="hidden" name="replace_basket_item_id" value={replaceBasketItemId || ''}/>
        <h2>Your Tube Lengths</h2>
        <AuthenticityToken />
        <table className="table table-bordered">
          <thead>
            <tr>
              <th></th>
              <th>Size</th>
              <th>Length</th>
              <th>Quantity</th>
              <th>Ex VAT</th>
              <th>Inc VAT</th>
            </tr>
          </thead>
          <tbody>
            {cutComponents()}
          </tbody>
        </table>
        <div className="btn-group">
          <input type="submit" className={`ui-button ui-state-default tube-submit ${cuts.length ? '' : 'disabled'}`} value="Add to Basket" disabled={!cuts.length}/>
        </div>
      </form>
    </section>
  )
}

Tube.propTypes = {
  products: PropTypes.array,
  replaceBasketItemId: PropTypes.number,
  defaultSize: PropTypes.string,
  vatRate: PropTypes.number
}

export default Tube
